import React from 'utils/react';

export default () => null;
